const enum Tone {
	FIRST,
	SECOND,
	THIRD,
	FORTH,
	NEUTRAL
}

export default Tone;